import React from "react";

const SignUpButton = () => {
  return (
    <button className="transition-all bg-[#6ED1F9] w-96 h-14 text-2xl font-noto-sans-kr text-white rounded-full hover:bg-white border-[3px] border-[#6ED1F9] hover:text-[#6ED1F9]">
      회원가입
    </button>
  );
};

export default SignUpButton;
